/**
 * "Write a review" (snippets/oracura-review-write.liquid).
 *
 * Opens the window; for a signed-in customer, the stars, the counter, the
 * checks and the send. A review goes to the store's inbox through Shopify's
 * contact form, one labelled field a line, with the steps to publish it.
 *
 * If the store's spam check stops the background send (Shopify answers with
 * /challenge), the same fields are posted as an ordinary form so the browser
 * can show the check; Shopify then brings the shopper back here with
 * ?contact_posted=true, and the window opens on its thank-you.
 */
(() => {
  if (window.OracuraReviewWrite) return;
  window.OracuraReviewWrite = true;

  const SENT = 'oracura-review-sent';
  const PENDING = 'oracura-review-pending';
  const sentList = () => { try { return JSON.parse(localStorage.getItem(SENT) || '{}'); } catch (e) { return {}; } };
  const markSent = (id) => { try { const all = sentList(); all[id] = Date.now(); localStorage.setItem(SENT, JSON.stringify(all)); } catch (e) { /* fine */ } };

  const fieldsFor = (dialog, form) => {
    const d = dialog.dataset;
    const data = new FormData(form);
    const rating = data.get('rating');
    const headline = String(data.get('headline') || '').trim();
    const body = String(data.get('body') || '').trim();
    const name = String(data.get('display_name') || '').trim();
    const verified = data.get('verified') === 'yes';
    const order = String(data.get('order') || '');
    const variant = String(data.get('variant') || '');
    const today = new Date().toISOString().slice(0, 10);
    const fields = {
      form_type: 'contact',
      utf8: '✓',
      'contact[email]': String(data.get('email') || ''),
      'contact[name]': name,
      'contact[Subject]': 'New product review – ' + d.productTitle + ' – ' + rating + '/5',
      'contact[Product]': d.productTitle,
      'contact[Product URL]': d.productUrl,
      'contact[Rating]': rating + ' / 5',
      'contact[Headline]': headline || '-',
      'contact[Review]': body,
      'contact[Display name]': name,
      'contact[Verified buyer]': verified ? 'yes' + (order ? ' (order ' + order + ')' : '') : 'no',
      'contact[Variant bought]': variant || '-',
      'contact[Customer ID]': String(data.get('customer_id') || ''),
      'contact[Submitted]': today,
      'contact[body]': [
        'A customer has written a review. To publish it:',
        '1. Admin > Content > Metaobjects > the product reviews (type spectrum_product_review) > Add entry:',
        '   Title = the headline, Body = the review, Rating = the stars, Author display name = the display name,',
        '   Submitted at = ' + today + ', App verification status = ' + (verified ? 'verified_buyer' : 'unverified') + (variant ? ', Variant title = ' + variant : '') + '.',
        '2. Products > ' + d.productTitle + ' > Metafields > Product reviews: add the new entry to the list.',
      ].join('\n'),
    };
    return { fields, body, rating, name };
  };

  async function send(fields) {
    const body = new URLSearchParams();
    Object.entries(fields).forEach(([k, v]) => body.set(k, v));
    const response = await fetch('/contact', { method: 'POST', body, headers: { Accept: 'text/html' } });
    if (/\/challenge/.test(response.url)) return 'challenge';
    if (!response.ok || !/contact_posted=true/.test(response.url)) throw new Error('contact ' + response.status);
    return 'sent';
  }

  // The spam check: post the same fields as a real form, so the browser can
  // show it, and remember what to open on the way back.
  function sendThroughChallenge(dialog, fields) {
    try { sessionStorage.setItem(PENDING, dialog.dataset.productId); } catch (e) { /* fine */ }
    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/contact';
    form.hidden = true;
    Object.entries(fields).forEach(([k, v]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = k;
      input.value = v;
      form.append(input);
    });
    document.body.append(form);
    form.submit();
  }

  function showThanks(dialog) {
    const form = dialog.querySelector('[data-review-write-form]');
    const thanks = dialog.querySelector('[data-review-thanks]');
    if (form) form.hidden = true;
    if (thanks) thanks.hidden = false;
    markSent(dialog.dataset.productId);
    labelSent(dialog.dataset.productId);
  }

  function labelSent(productId) {
    document.querySelectorAll('[data-review-write-open]').forEach((button) => {
      const dialog = document.getElementById(button.dataset.reviewWriteOpen);
      if (!dialog || dialog.dataset.productId !== String(productId)) return;
      button.classList.add('is-sent');
      const label = button.querySelector('[data-review-write-label]');
      if (label && dialog.dataset.sentLabel) label.textContent = dialog.dataset.sentLabel;
    });
  }

  function bind(dialog) {
    if (dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-review-write-close]')) dialog.close();
    });

    const form = dialog.querySelector('[data-review-write-form]');
    if (!form) return;
    const error = form.querySelector('[data-review-error]');
    const submit = form.querySelector('[data-review-submit]');
    const textarea = form.querySelector('textarea[name="body"]');
    const count = form.querySelector('[data-review-count]');
    const word = form.querySelector('[data-review-star-word]');
    const stars = form.querySelector('[data-review-stars]');

    const showWord = (text) => { if (word) word.textContent = text || ''; };
    const chosenWord = () => {
      const on = form.querySelector('input[name="rating"]:checked');
      return on ? form.querySelector('label[for="' + on.id + '"]').dataset.word : '';
    };
    stars.addEventListener('pointerover', (event) => {
      const label = event.target.closest('.oracura-rw__star');
      if (label) {
        showWord(label.dataset.word);
        stars.dataset.hover = label.htmlFor.split('-').pop();
      }
    });
    stars.addEventListener('pointerleave', () => { delete stars.dataset.hover; showWord(chosenWord()); });
    stars.addEventListener('change', () => { showWord(chosenWord()); if (error) error.hidden = true; });

    const updateCount = () => { if (count) count.textContent = String(textarea.value.length); };
    textarea.addEventListener('input', updateCount);
    updateCount();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const { fields, body, rating, name } = fieldsFor(dialog, form);
      const fail = (message, focus) => {
        error.textContent = message;
        error.hidden = false;
        if (focus) focus.focus();
      };
      const L = dialog.dataset;
      if (!rating) return fail(L.errRating, form.querySelector('input[name="rating"]'));
      if (body.length < 30) return fail(L.errBody, textarea);
      if (!name) return fail(L.errName, form.querySelector('input[name="display_name"]'));
      error.hidden = true;
      submit.disabled = true;
      const original = submit.textContent;
      submit.textContent = L.sending || '…';
      try {
        const result = await send(fields);
        if (result === 'challenge') { sendThroughChallenge(dialog, fields); return; }
        showThanks(dialog);
      } catch (err) {
        fail(L.errSend);
      } finally {
        submit.disabled = false;
        submit.textContent = original;
      }
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-review-write-open]');
    if (!button) return;
    const dialog = document.getElementById(button.dataset.reviewWriteOpen);
    if (!dialog) return;
    event.preventDefault();
    bind(dialog);
    if (sentList()[dialog.dataset.productId]) {
      const form = dialog.querySelector('[data-review-write-form]');
      const thanks = dialog.querySelector('[data-review-thanks]');
      if (form && thanks) { form.hidden = true; thanks.hidden = false; }
    }
    dialog.showModal();
    const first = dialog.querySelector('input[name="rating"], .oracura-rw__signin a');
    if (first) first.focus();
  });

  const init = () => {
    const all = sentList();
    document.querySelectorAll('[data-review-write]').forEach((dialog) => {
      if (all[dialog.dataset.productId]) labelSent(dialog.dataset.productId);
    });
    // Back from the spam check, or from signing in to write one.
    let pending = null;
    try { pending = sessionStorage.getItem(PENDING); } catch (e) { /* fine */ }
    if (pending && /contact_posted=true/.test(location.search)) {
      try { sessionStorage.removeItem(PENDING); } catch (e) { /* fine */ }
      const dialog = document.querySelector('[data-review-write][data-product-id="' + pending + '"]');
      if (dialog) { bind(dialog); showThanks(dialog); dialog.showModal(); }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
